export const WEBSITE = {
    DOMAIN: 'www.magazineslovers.com',
}